var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD16Profile = function SvgD16Profile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 2.383a2.15 2.15 0 1 1 0 4.3 2.15 2.15 0 0 1 0-4.3zM7.999 12.8a4.77 4.77 0 0 1-3.107-1.146.916.916 0 0 1-.321-.696c0-1.204.974-2.168 2.178-2.168h2.502c1.205 0 2.175.964 2.175 2.168a.914.914 0 0 1-.32.696A4.769 4.769 0 0 1 7.998 12.8z",
    fill: "#FFF"
  })));
};
export default SvgD16Profile;